import gql from "graphql-tag";

export const UPDATE_TRELLO = gql`
  mutation ($input: updateTrelloInput) {
    updateTrello(input: $input) {
      _id
      user {
        _id
      }
      workspace {
        _id
      }
      api_token
      sync {
        trello_board
        windu_project
        list_pull {
          id
          name
        }
        list_push_start {
          id
          name
        }
        list_push_finished {
          id
          name
        }
      }
    }
  }
`;
